export default __webpack_public_path__ + "static/media/Siegebreaker.e5594e27.jpg";